var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.purchReceipt, rules: _vm.rules }
        },
        [
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("验收单信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "input-tip error font12" }, [
              _vm._v("临采的资产因供应商线下维保，无法按保内处理")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form flex col-4" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("请购部门/门店")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "recvComName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.purchReceipt.recvComName,
                          callback: function($$v) {
                            _vm.$set(_vm.purchReceipt, "recvComName", $$v)
                          },
                          expression: "purchReceipt.recvComName"
                        }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass:
                          "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        on: { click: _vm.selectSrcComName }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("标题")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.purchReceipt.title,
                          callback: function($$v) {
                            _vm.$set(_vm.purchReceipt, "title", $$v)
                          },
                          expression: "purchReceipt.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("外部审批单号")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "auditPoofNo" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.purchReceipt.auditPoofNo,
                          callback: function($$v) {
                            _vm.$set(_vm.purchReceipt, "auditPoofNo", $$v)
                          },
                          expression: "purchReceipt.auditPoofNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.showBizUnitWarehouse
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("入库仓库")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "warehouseId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: true },
                              model: {
                                value: _vm.purchReceipt.warehouseId,
                                callback: function($$v) {
                                  _vm.$set(_vm.purchReceipt, "warehouseId", $$v)
                                },
                                expression: "purchReceipt.warehouseId"
                              }
                            },
                            _vm._l(_vm.warehouseList, function(item) {
                              return _c("el-option", {
                                attrs: { label: item.name, value: item.id }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("供应商信息")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.selectTmpVendor()
                  }
                }
              },
              [_vm._v("选择供应商")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form flex col-4" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("供应商名称")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.purchReceipt.sellerRealComName || ""))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("统一社会代码")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.purchReceipt.sellerSocialCreditCode || ""))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("业务联系人")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.purchReceipt.sellerContactName || ""))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("业务联系方式")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.purchReceipt.sellerContactTel || ""))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("结算单信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form flex col-4" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("发票类型")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "ul",
                  { staticClass: "enum-list" },
                  _vm._l(_vm.invoiceTypeList, function(merchantInvoiceType) {
                    return _c(
                      "li",
                      {
                        staticClass: "enum-item",
                        class: {
                          checked:
                            merchantInvoiceType.value ==
                            _vm.purchReceipt.invoiceType
                        },
                        on: {
                          click: function($event) {
                            _vm.invoiceTypeChange(merchantInvoiceType.value)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(merchantInvoiceType.text)
                        ),
                        _c("i")
                      ]
                    )
                  })
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("是否抵扣税")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _vm.purchReceipt.invoiceType == 1
                    ? _c("span", [_vm._v("否")])
                    : _c(
                        "el-form-item",
                        { attrs: { prop: "taxOffset" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: {
                                change: function($event) {
                                  _vm.changeTaxOffset()
                                }
                              },
                              model: {
                                value: _vm.purchReceipt.taxOffset,
                                callback: function($$v) {
                                  _vm.$set(_vm.purchReceipt, "taxOffset", $$v)
                                },
                                expression: "purchReceipt.taxOffset"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: true }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "否", value: false }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("税率(%)")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "taxRate" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择税率" },
                          on: {
                            change: function($event) {
                              _vm.changeActualAmount()
                            }
                          },
                          model: {
                            value: _vm.purchReceipt.taxRate,
                            callback: function($$v) {
                              _vm.$set(_vm.purchReceipt, "taxRate", $$v)
                            },
                            expression: "purchReceipt.taxRate"
                          }
                        },
                        _vm._l(_vm.fiscalTaxMarkList, function(item) {
                          return _c("el-option", {
                            key: item.rate,
                            attrs: { label: item.rate, value: item.rate }
                          })
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("验收条目")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.showDevcDefListDlg()
                  }
                }
              },
              [_vm._v("选择资产定义")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-layout" }, [
            _vm.purchReceipt.goodsItemList != null &&
            _vm.purchReceipt.goodsItemList.length > 0
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "simple-row" }, [
                      _c("div", { staticClass: "right" }, [
                        _vm.purchReceipt.goodsItemList != null
                          ? _c("span", [
                              _vm._v(
                                "已选择(" +
                                  _vm._s(
                                    _vm.purchReceipt.goodsItemList.length
                                  ) +
                                  ")"
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.purchReceipt.goodsItemList,
                          border: "",
                          "tooltip-effect": "dark",
                          maxHeight: "400"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "assetDefNo",
                            label: "资产定义编码",
                            width: "200",
                            fixed: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "assetDefName",
                            label: "资产定义名称",
                            width: "100",
                            fixed: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "assetNature",
                            label: "资产属性",
                            width: "100",
                            fixed: "left",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.assetNatureMap[rows.row.assetNature]
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "model",
                            label: "型号",
                            width: "150",
                            fixed: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "fixedSpec",
                            label: "规格",
                            width: "150",
                            fixed: "left",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "brandName",
                            label: "资产品牌",
                            width: "240"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "catName",
                            label: "资产分类",
                            width: "240"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "wtxPrice",
                            width: "100",
                            label: "含税单价(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "goodsItemList." +
                                          rows.$index +
                                          ".wtxPrice",
                                        rules: {
                                          validator: _vm.validateWtxPrice,
                                          trigger: "blur"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "text" },
                                        on: {
                                          change: function($event) {
                                            _vm.wtxPriceChange(rows.row)
                                          }
                                        },
                                        model: {
                                          value: rows.row.wtxPrice,
                                          callback: function($$v) {
                                            _vm.$set(rows.row, "wtxPrice", $$v)
                                          },
                                          expression: "rows.row.wtxPrice"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "wrntPeriod",
                            width: "100",
                            label: "质保期(月)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("el-input", {
                                    attrs: { type: "text" },
                                    model: {
                                      value: rows.row.wrntPeriod,
                                      callback: function($$v) {
                                        _vm.$set(rows.row, "wrntPeriod", $$v)
                                      },
                                      expression: "rows.row.wrntPeriod"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "quantity",
                            width: "100",
                            label: "数量"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("el-input", {
                                    attrs: { type: "text" },
                                    on: {
                                      change: function($event) {
                                        _vm.quantityChange(rows.row)
                                      }
                                    },
                                    model: {
                                      value: rows.row.quantity,
                                      callback: function($$v) {
                                        _vm.$set(rows.row, "quantity", $$v)
                                      },
                                      expression: "rows.row.quantity"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxRate",
                            align: "right",
                            width: "100",
                            label: "税率(%)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        parseFloat(rows.row.taxRate).toFixed(
                                          2
                                        ) || 0.0
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxPrice",
                            align: "right",
                            width: "100",
                            label: "未税单价(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.ntxPrice != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              rows.row.ntxPrice
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wtxAmount",
                            align: "right",
                            width: "100",
                            label: "含税小计(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.wtxAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              rows.row.wtxAmount
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ntxAmount",
                            align: "right",
                            width: "100",
                            label: "未税小计(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.ntxAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              rows.row.ntxAmount
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "taxAmount",
                            align: "right",
                            width: "100",
                            label: "税额小计(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.taxAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              rows.row.taxAmount
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "unit",
                            "min-width": "50",
                            label: "单位"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "100",
                            label: "操作",
                            fixed: "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.removeGoods(rows.$index)
                                        }
                                      }
                                    },
                                    [_vm._v("移除")]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "swb-btn swb-btn-small",
          on: {
            click: function($event) {
              _vm.showDialogFile()
            }
          }
        },
        [_vm._v("上传")]
      ),
      _vm._v(" "),
      _vm.fileList != null && _vm.fileList.length > 0
        ? _c(
            "div",
            { staticClass: "file-view-list" },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm._l(_vm.fileList, function(fileInfo, index) {
                return [
                  _c("swb-file-item-li", {
                    attrs: {
                      trackKey: index,
                      fileName: fileInfo.name,
                      fileBrowseUrl: fileInfo.fileBrowseUrl,
                      fileDownloadUrl: fileInfo.fileBrowseUrl,
                      fileUuid: fileInfo.fileUuid,
                      deletable: true,
                      onDelete: _vm.deleteFile
                    }
                  })
                ]
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("附件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57369e90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57369e90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/PurchReceiptTmpSave.vue
// module id = 2999
// module chunks = 0